const buttons = {
	add: "Add",
	add_qemu: "Add VPS",
	block: "Block",
	calculate: "Calculate",
	cancel: "Cancel",
	change_template: "Change template",
	check: "Check",
	choose: "Configure",
	close: "Close",
	confirm: "Confirm",
	connect: "Link",
	copied: "Copied!",
	copy: "Copy",
	create: "Create",
	deblock: "Deblock",
	delete: "Delete",
	details: "Details",
	disconnect: "Disconnect",
	edit: "Edit",
	get_details: "Get details",
	leave: "Leave",
	more_info: "More information",
	next: "Next",
	order: "Order",
	previous: "Previous",
	resend: "Resend",
	reset: "Reset",
	save: "Save",
	search: "Search",
	select: "Select",
	selected: "Selected",
	send: "Send",
	show_details: "Show details",
	sign_in: "Sign in",
	sign_in_return: "Back to login page",
	sign_up: "Sign up",
	start_tour: "Start tour",
	update: "Update",
	view: "View",
};

export default buttons;
